import { isoZ, z } from 'my-zod'
import { currencyEnum } from '../../internal'
import { transferMetadata } from './transfer-metadata'

export const transferModel = z.object({
  id: z.number() /** auto inc */,
  transferGroup: z.string(),
  source: z.string(),
  destination: z.string(),
  amount: z.number().positive().int() /** amount transferred to the destination. USD are in cents. */,
  currency: currencyEnum,
  withdrawalDescription: z.string(),
  depositDescription: z.string(),
  notes: z.string().max(256).nullable(),
  createdDate: isoZ.instant(),
  metadata: transferMetadata,
  reversals: z
    .object({
      id: z.number(),
      amount: z.number().positive().int(),
      createdDate: isoZ.instant(),
      metadata: transferMetadata
    })
    .array()
})

export type transferModel = z.infer<typeof transferModel>
